"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const hauling_types_1 = require("./hauling.types");
const constants_1 = require("utils/constants");
const initialState = {
    dataGrid: [],
    errorCode: 0,
    isError: false,
    errorMessage: '',
    isLoading: false,
    isSuccess: false,
    mutationMode: false,
    dataGridHistory: [],
    dataGridBrand: [],
    isLoadingSubmit: false,
    isLoadingUpload: false,
    isLoadingDownload: false,
    lastUpdated: new Date(),
    lastUpdatedBrand: new Date(0),
    selectedYear: new Date().getFullYear().toString(),
    selectedYearBrand: new Date().getFullYear().toString(),
    dataItem: {
        id: '',
        contractor_id: '',
        contractor_code: '',
        brand_id: '',
        brand_name: '',
        unit: 0,
        trip: 0,
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        mei: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        year: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date()
    },
    dataItemBrand: {
        id: '',
        brand_id: '',
        brand_code: '',
        jan: 0,
        feb: 0,
        mar: 0,
        apr: 0,
        may: 0,
        jun: 0,
        jul: 0,
        aug: 0,
        sep: 0,
        oct: 0,
        nov: 0,
        dec: 0,
        year: '',
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date(),
        brand_id_rs: '',
        brand_id_sm: '',
        brand_data_rs: 0,
        brand_data_sm: 0,
        month: constants_1.month[new Date().getMonth()],
    },
    dataItemHistory: {
        id: '',
        log_message: '',
        status: '',
        filename: '',
        filepath: '',
        uploaded_by: '',
        uploaded_at: new Date(),
        year: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'contractor_code', dir: 'asc' },
        ]
    },
    dataStatesBrand: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'brand_code', dir: 'asc' },
        ]
    },
    dataStatesHistory: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [
            { field: 'uploaded_at', dir: 'desc' },
        ]
    },
};
const haulingProductionReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HAULING]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HAULING_BRAND]: (state, action) => {
        const { dataGridBrand, count, dataTotal, lastUpdatedBrand } = action.payload;
        const { jan, feb, mar, apr, may, jun, jul, aug, sep, oct, nov, dec } = dataTotal;
        const total = [{
                id: '',
                brand_id: '',
                brand_code: 'Total',
                jan: jan,
                feb: feb,
                mar: mar,
                apr: apr,
                may: may,
                jun: jun,
                jul: jul,
                aug: aug,
                sep: sep,
                oct: oct,
                nov: nov,
                dec: dec,
                year: '',
                created_by: '',
                created_date: new Date(),
                modified_by: '',
                modified_date: new Date()
            }];
        return Object.assign(Object.assign({}, state), { isLoading: false, lastUpdatedBrand: lastUpdatedBrand, dataGridBrand: dataGridBrand.concat(total), dataStatesBrand: Object.assign(Object.assign({}, state.dataStatesBrand), { total: count }) });
    },
    [hauling_types_1.planningHaulingTypes.SET_DATA_GRID_HISTORY]: (state, action) => {
        const { count, dataGridHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGridHistory, isLoading: false, dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { total: count }) });
    },
    [hauling_types_1.planningHaulingTypes.SET_LAST_SUCCEED_UPLOAD]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, lastUpdated: action.payload.lastUpdated });
    },
    [hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [hauling_types_1.planningHaulingTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, isSuccess, mutationMode, selectedYear, dataItemBrand, dataItemHistory, isLoadingUpload, isLoadingSubmit, isLoadingDownload, selectedYearBrand, } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, selectedYear: selectedYear ? selectedYear : initialState.selectedYear, dataItemBrand: dataItemBrand ? dataItemBrand : initialState.dataItemBrand, isLoadingUpload: isLoadingUpload ? isLoadingUpload : initialState.isLoadingUpload, isLoadingSubmit: isLoadingSubmit ? isLoadingSubmit : initialState.isLoadingSubmit, dataItemHistory: dataItemHistory ? dataItemHistory : initialState.dataItemHistory, isLoadingDownload: isLoadingDownload ? isLoadingDownload : initialState.isLoadingDownload, selectedYearBrand: selectedYearBrand ? selectedYearBrand : initialState.selectedYearBrand });
    },
    [hauling_types_1.planningHaulingTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItemBrand, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, isLoading: true, mutationMode: false, isLoadingSubmit: false, dataItemBrand: initialState.dataItemBrand, dataGridBrand: state.dataGridBrand.map(item => {
                if (item.id === dataItemBrand.id)
                    return dataItemBrand;
                return item;
            }) });
    },
    [hauling_types_1.planningHaulingTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isSuccess: false, isLoading: false, isLoadingSubmit: false, isLoadingUpload: false, isLoadingDownload: false });
    },
    [hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE_HISTORY]: (state, action) => {
        const { dataStatesHistory } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesHistory, isLoading: true });
    },
    [hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, filter: action.payload }) });
    },
    [hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE_HISTORY]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesHistory: Object.assign(Object.assign({}, state.dataStatesHistory), { isLoading: true, sort: action.payload }) });
    },
    [hauling_types_1.planningHaulingTypes.ON_PAGE_CHANGE_BRAND]: (state, action) => {
        const { dataStatesBrand } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStatesBrand, isLoading: true });
    },
    [hauling_types_1.planningHaulingTypes.ON_FILTER_CHANGE_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesBrand: Object.assign(Object.assign({}, state.dataStatesBrand), { isLoading: true, filter: action.payload }) });
    },
    [hauling_types_1.planningHaulingTypes.ON_SORT_CHANGE_BRAND]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStatesBrand: Object.assign(Object.assign({}, state.dataStatesBrand), { isLoading: true, sort: action.payload }) });
    }
});
exports.default = haulingProductionReducer;
